import { Component } from "react"

import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { Button, Card, Divider, Loader } from "semantic-ui-react"

import api from "api"
import ChallengeCard from "components/lib/Cards/ChallengeCard"
import { EmptyBox } from "components/lib/UI"

class PublicChallenges extends Component {
  constructor(props) {
    super(props)
    this.state = {
      challenges: [],
      loading: false,
    }
  }

  componentDidMount() {
    this.fetchChallenges()
  }

  componentDidUpdate(prevProps) {
    const { organisation } = this.props
    if (organisation?._id !== prevProps.organisation?._id) {
      this.fetchChallenges()
    }
  }

  fetchChallenges = () => {
    const { organisation } = this.props
    if (organisation) {
      this.setState({ loading: true })
      api.organisations.getShopWindow(organisation._id, ({ challenges }) => {
        this.setState({ loading: false, challenges })
      })
    }
  }

  render() {
    const { organisation, user, t } = this.props
    const { challenges, loading } = this.state
    const openChallenges = challenges
      .filter((challenge) => challenge.stage === "published")
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    const closedChallenges = challenges
      .filter((challenge) => challenge.stage === "closed")
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))

    return (
      <div style={{ paddingLeft: 30 }}>
        <h1 className="title" style={{ color: "#3b3b3b" }}>
          Public {t("generic.challenges")}
        </h1>
        {!user && (
          <Link to="/">
            <p style={{ fontSize: 14 }}>
              <u>Sign up or log in to discover more</u>
            </p>
          </Link>
        )}
        {user && (
          <Link to="/challenges/discover">
            <p style={{ fontSize: 14 }}>
              <u>Discover more {t("generic.challenges")}</u>
            </p>
          </Link>
        )}
        <Divider />

        {loading ? (
          <Loader style={{ marginTop: 20 }} active inline="centered" />
        ) : (
          <div>
            {organisation ? (
              <div>
                {challenges !== null && challenges.length >= 1 && (
                  <>
                    {openChallenges.length > 0 && (
                      <>
                        <h3>Published {t("generic.challenges")}</h3>
                        <Card.Group itemsPerRow={4} stackable>
                          {openChallenges.map((challenge) => (
                            <ChallengeCard challenge={challenge} key={challenge._id} />
                          ))}
                        </Card.Group>
                      </>
                    )}
                    {closedChallenges.length > 0 && (
                      <>
                        <h3>Closed {t("generic.challenges")}</h3>
                        <Card.Group itemsPerRow={4} stackable>
                          {closedChallenges.map((challenge) => (
                            <ChallengeCard challenge={challenge} key={challenge._id} />
                          ))}
                        </Card.Group>
                      </>
                    )}
                  </>
                )}
                {challenges.length === 0 && (
                  <EmptyBox style={{ margin: "20px 40px" }}>
                    <h2>There aren't any public {t("generic.challenges")} right now</h2>
                    {user ? (
                      <Button
                        size="large"
                        as={Link}
                        to="/challenges/discover"
                        primary
                        icon="eye"
                        content={`Discover ${t("generic.challenges")}`}
                      />
                    ) : (
                      <Button size="large" as={Link} to="/" primary content="Sign up or log in" />
                    )}
                  </EmptyBox>
                )}
              </div>
            ) : (
              <EmptyBox style={{ margin: "20px 40px" }} title={`No public ${t("generic.challenges")} available`} />
            )}
          </div>
        )}
        <Divider hidden />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({ organisation: state.organisations.urlOrganisation, user: state.user })

const PublicChallengesContainer = withTranslation()(connect(mapStateToProps)(PublicChallenges))

export default PublicChallengesContainer
